export const APP_NAME = 'YOUR_APP_NAME';
export const USER_NAME = '';
export const TENANT = 'YOUR_TENANT';
export const NAMESPACE = 'YOUR_DOMAIN';
export const GUARDIAN_NAMESPACE = 'YOUR_AUTH0_GUARDIAN_DOMAIN';
export const CLIENT_ID = 'YOUR_CLIENT_ID';
export const CLIENT_SECRET = 'YOUR_CLIENT_SECRET';
export const CALLBACK = 'https://YOUR_APP/callback';
export const API_IDENTIFIER = 'YOUR_API_IDENTIFIER';
export const CONNECTION_NAME = 'YOUR_CONNECTION_NAME';
